/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-23T10:16:15-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-13T10:03:32-07:00
*/

import { StyleSheet } from 'aphrodite/no-important';
import { spacing, leading } from '../../../../style'

const style = StyleSheet.create({

  msg: {
    ...spacing.MARGIN_BOTTOM_SM
  },

  /* Message row bewteen each message entry */
  msgContainer : {
    // marginBottom: '12px',
    display: 'flex',
    alignItems: 'flex-end',
  },

  /* switch flow direction depending on whether a msg is sent or recieved */
  isSent: {
    flexDirection: 'row-reverse',
  },

  msgAvatar: {
    height: '38px',
    width: '38px',
  },

/* Add spacing to right or left of avatars if msg is received or sent */
  msgAvatar_isReceived: {
    marginRight: '12px',
  },

  msgAvatar_isSent: {
    marginLeft: '12px',

  },

  continued: {
    visibility: 'hidden'
  },

  /* Ensure img is full size of avatar component */
  msgAvatarImg: {
    height: '100%',
    width: '100%'
  },

  /* messsage bubble area */
  msgMessage: {
    backgroundColor: '#EEE',
    maxWidth: '60%',
    position: 'relative',
  },

  caret: {
    ':before': {
      content: '""',
      borderStyle: 'solid',
      borderWidth: '6px',
      display: 'block',
      position: 'absolute',
      height: '0',
      width: '0',
      bottom: '14px',
      borderColor: '#EEE'

    }
  },

  caret_right: {
    ':before': {
      left: 'auto',
      right: '-5px',
      borderRightWidth: '0',
      borderTopColor: 'transparent',
      borderBottomColor: 'transparent',
      // borderLeftColor: 'transparent'
    }
  },

  caret_left: {
    ':before': {
      left: '-5px',
      borderLeftWidth: '0',
      borderTopColor: 'transparent',
      borderBottomColor: 'transparent',

    }
  },

  msgFooter: {
    fontSize: '12px',
    margin: '0 50px',
    ...leading.LOOSE
  },

  msgFooter_isSent: {
    textAlign: 'right',
  },

  msgText: {
    margin: '0',
    padding: '12px',
    whiteSpace: 'pre-wrap'
  },

  msgFooter_isReceived: {

  }
});

export default style;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MsgItem/style.jsx